import { defineComponent, useListeners, computed, ref, inject } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';
import { useStoreModule } from '../../composables/store-module/index.js';
import { useTableRow } from '../../composables/table-row/index.js';
import UiName from '../ui-name/UiName.vue.js';
import UiValue from '../ui-value/UiValue.vue.js';
import HoistComponent from '../hoist-component/HoistComponent.vue.js';
import UiValueBar from '../ui-value-bar/UiValueBar.vue.js';
import { showResults, showNoResults } from '../../helpers/data.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "PortfolioPositionsPerformance",
  props: {
    locale: { type: null, required: true },
    id: { type: null, required: true },
    itemsShown: { type: Number, required: false, default: 3 },
    sort: { type: String, required: false, default: "top" }
  },
  emits: ["store-error", "data-load", "table-row-key-click", "table-row-click"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const listeners = useListeners();
    const componentInputs = computed(() => ({
      id: props.id,
      sort: props.sort,
      itemsShown: props.itemsShown,
      language: props.locale
    }));
    const headers = ref([
      { key: "name", label: "portfolioPositionsPerformance.label.name", subtitle: "portfolioPositionsPerformance.label.isin" },
      { key: "performance", label: "portfolioPositionsPerformance.label.performanceRelative", subtitle: "portfolioPositionsPerformance.label.performance" },
      { key: "performance-bar", label: "portfolioPositionsPerformance.label.performanceBar" }
    ]);
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter"),
      dateFormatter: inject("dateFormatter")
    });
    const { translate, textFormat, numberFormat } = localizationSupport;
    const tableRow = useTableRow(listeners, emits);
    const { tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick } = tableRow;
    const storeModule = useStoreModule(
      { storeModule: inject("storeModule") },
      componentInputs,
      emits
    );
    const { storeData, isLoadingStoreData } = storeModule;
    const maxRelativeGainLoss = computed(() => {
      if (!storeData.value || storeData.value.length === 0) {
        return 0;
      }
      return Math.max(...storeData.value.map((item) => {
        var _a;
        return Math.abs((_a = item.gainLossRelative) != null ? _a : 0);
      }));
    });
    return { __sfc: true, props, emits, listeners, componentInputs, headers, localizationSupport, translate, textFormat, numberFormat, tableRow, tableRowAttributes, hasTableRowClickListener, hasTableRowKeyClickListener, tableRowEvents, onTableRowKeyClick, storeModule, storeData, isLoadingStoreData, maxRelativeGainLoss, UiName, UiValue, HoistComponent, UiValueBar, showResults, showNoResults };
  }
});

export { _sfc_main as default };
